<template>
  <v-fab-transition>
    <v-btn
      v-show="!isHidden"
      color="dark_blue"
      fixed
      right
      fab
      v-scroll="handleScroll"
      v-scroll-to="'#top_card'"
      style="color: #ffffff; bottom: 54px"
    >
      <v-icon>arrow_upward</v-icon>
    </v-btn>
  </v-fab-transition>
</template>

<script>
export default {
  name: 'BackTopButton',
  data() {
    return {
      isHidden: true
    };
  },
  methods: {
    handleScroll: function(evt, el) {
      if (window.scrollY > 200) {
        this.isHidden = false;
      }
      if (window.scrollY < 200) {
        this.isHidden = true;
      }
    },
    returnTop() {
      window.scrollY = 0;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_atoms/buttons/BackTopButton.vue